<template>

    <div class="container-fluid p-0">
        <div class="row m-0" v-if="!is_expired">
            <div class="col-12 p-0">
                <div class=" login-card  card login-dark">
                    <div  >
                        <div class="card-header"  >
                            <h4>Vehicle Details </h4>
                                                            <span v-if="request.approval_status==0" class="badge bg-warning text-white">Pending</span>
                                                            <span v-else-if="request.approval_status==1" class="badge bg-success  text-white">HOD Approved</span>
                                                            <span v-else-if="request.approval_status==2" class="badge bg-success  text-white">HR Approved</span>
                                                            <span v-else-if="request.approval_status==3" class="badge bg-success  text-white">Security Approved</span>
                                                            <span v-else-if="request.approval_status==4" class="badge bg-danger  text-white">HOD Declined</span>
                                                            <span v-else-if="request.approval_status==5" class="badge bg-danger  text-white">HR Declined</span>
                                                            <span v-else-if="request.approval_status==6" class="badge bg-danger  text-white">Security Declined</span>
                                                            <span v-else-if="request.approval_status==7" class="badge bg-warning  text-white">On Hold</span>
 
                        </div>

                        <div class="card-body bg-white">
 
                            <div class="col-12 row">
                                <div class=" col-12 text-center"> 
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                               <table class="table">
                                    <tr class="bottomborder">
                                            <td><b>Emp Code:</b> </td>
                                            <td> {{ request.empcode }}</td>
                                        </tr>
                                        <tr class="bottomborder">
                                            <td><b>Name:</b> </td>
                                            <td> {{ request.empname }}</td>
                                        </tr>
                                        <tr class="bottomborder">
                                            <td><b>Phone No.:</b> </td>
                                            <td> {{ request.contact }}</td>
                                        </tr>
                                        <tr class="bottomborder">
                                            <td><b>Department:</b> </td>
                                            <td> {{ request.dept_name }}</td>
                                        </tr>
                                </table>
                                 <hr>
                            <table class="table">
                                 <tr class="bottomborder">
                                        <td><b>Type</b></td>
                                        <td>{{ request.req_type }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Purpose</b></td>
                                        <td>{{ request.purpose }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Source</b></td>
                                        <td>{{ request.source }}</td>
                                    </tr>
                                    <tr   class="bottomborder">
                                        <td><b>Destination</b></td>
                                        <td>{{ request.destination }}</td>
                                    </tr> 
                                    <tr   class="bottomborder">
                                        <td><b>Check Out</b></td>
                                        <td>{{ request.schedule_checkout_date + '   -  '+request.schedule_checkout_time }}</td>
                                    </tr> 
                                    <tr   class="bottomborder">
                                        <td><b>Check In</b></td>
                                        <td>{{ request.schedule_checkin_date + '   -  '+request.schedule_checkin_time }}</td>
                                    </tr> 
                                    
                                     <tr v-if="request.checkout_date" class="bottomborder light_red">
                                        <td><b>Security Check Out</b></td>
                                        <td>{{ request.checkout_date }}</td>
                                    </tr> 
                                    <tr v-if="request.checkin_date" class="bottomborder  light_green">
                                        <td><b>Security Check In</b></td>
                                        <td>{{ request.checkin_date }}</td>
                                    </tr> 
                                    
                                    
                                </table>
                            </div> 
                               
                        </div>
                        <div class="card-footer bg-white"  v-if="scan_user && scan_user.empdept==sd">
                            <div class="col-12 row" v-if="request.approval_status==3">
                                <button class="btn btn-danger  col-12" v-if="request.checkout_date==null" @click="mark_checkin(request.token,2)">Check Out  </button>
                                <button class="btn btn-success col-12" v-if="request.checkout_date!=null && request.checkin_date==null"  @click="mark_checkin(request.token,1)">Check In </button>
                            </div>
                             <div class="col-12 row" v-if="request.approval_status==2">
                                 <div class="col-12 row" >
                                    <button class="btn btn-success col-4" @click="process(request.token,3)">Approve </button>
                                 <div class="col-4"></div>
                                    <button class="btn btn-danger  col-4" @click="process(request.token,6)">Decline  </button>
                                </div> 
                            </div>
                            
                        </div> 
                          <div class="card-footer bg-white"  v-else-if="request.approval_status==2 && scan_user.empdept==sd">
                            <div class="col-12 row" >
                                <button class="btn btn-success col-4" @click="process(request.token,3)">Approve </button>
                                <div class="col-4"></div>
                                <button class="btn btn-danger  col-4" @click="process(request.token,6)">Decline  </button>
                            </div> 
                          </div> 
                          
                        <div class="card-footer bg-white"  v-else-if="request.approval_status==1 && isadmin==true">
                            <div class="col-12 row" >
                                <button class="btn btn-success col-4" @click="process(request.token,2)">Approve </button>
                                <div class="col-4"></div>
                                <button class="btn btn-danger  col-4" @click="process(request.token,5)">Decline  </button>
                            </div> 
                          </div> 
                          
                          <div class="card-footer bg-white"  v-else-if="request.approval_status==0 && request.hod_id==scan_user.id">
                            <div class="col-12 row" >
                                <button class="btn btn-success col-4" @click="process(request.token,1)">Approve </button>
                                <div class="col-4"></div>
                                <button class="btn btn-danger  col-4" @click="process(request.token,4)">Decline  </button>
                            </div> 
                          </div> 
                          
                            
                          
                    </div>
                    
                </div>
            </div>
        </div>
    </div>





</template>
<style scoped>
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
.avatar img{
    width: 100%; 
}
.login-card {
    min-height: 80vh;
}
.light_red{
       background: #ffcbcb; 
}
.light_green{
       background: #cbffcf;
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'VehicleRequestProcess',
    components: {

    },
    mounted() {
        if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }else
            window.location.href = this.$cur_host+'login';
    },
    data() {
        return {  
            request: { "empname": '', "empname": '',"contact": '', "purpose": '','dept_name':'','source':'','destination':'','schedule_checkout_date':'','schedule_checkout_time':'','schedule_checkin_date':'','schedule_checkin_time':'','approval_status':'' },
            status:'',
            scan_user:[],
            sd:0,
            is_expired:false,
            isadmin:false
        }
    },
    methods: {  
        
         mark_checkin(passid,what) {
            var self = this;
            self.$swal({
                title: "Do You Want To Check In?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                
                    
            
                    const formData = new FormData();
                     
                    formData.append('passid', passid);
                    formData.append('what', what);
                    
                    axios.post('qrVehiclecheckInUser', formData).then(function (response) {
                        if(response.data.is==1){
                            // self.gatepass= response.data.gatepass; 
                              self.request= response.data.request;
                        //   self.showimgModal=false;
                        }
                            self.$swal(response.data.gatepassReq);
                    });
                }
            });

        },
        
        getBasics(token) {
            var self = this;
            axios.post('getvehicalrequest',{token:token}).then(function (response) {
                
                   self.request= response.data.request;
                   if(self.request){
                       self.scan_user= response.data.scan_user;
                       self.sd= response.data.sd;
                       self.getQrCode(self.request.token);
                              self.isadmin= response.data.isadmin;
                       console.log( self.request.approval_status+"   >    "+  self.isadmin);
                   }else{
                       self.is_expired=true;
                       self.$swal("Sorry Page Expired");
                       
                   }
                window.scrollTo(0, 0);
            });
        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                 var url=this.$api_host+'vehiclepassview?q='+token;
                   //var url='http://192.168.1.8:8081/vehiclepassview?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          }, 
        process(req_toke,what){
            var self = this;
            self.$swal({
                title: "Do You Want To Accept?",
                text: "Just confirmation ?",
                type: "warning",
                showCancelButton: true, 
            }).then((result) => { // <--
                    if(result.value){
                        axios.post('processVehicalRequest', {req_toke:req_toke,what:what}).then(function (response) {
                            if(response.data.is==1){
                                self.status=what;//response.data.gatepassReq;
                                // self.visit=response.data.visit;
                                self.request= response.data.request;
                            }
                            
                            self.$swal(response.data.gatepassReq);
                            
                                window.scrollTo(0, 0);
                            }) 
                    } 
                });
          }

}
}
</script>
